import React from 'react';
import { useEffect } from 'react';
const SessionTimeout = ({ children }) => {
    const handleOnIdle = () => {
        //const isLoggedIn = localStorage.getItem("access_token");
        // if (isLoggedIn && isLoggedIn != null) {
        //     localStorage.removeItem('access_token');
        //     sessionStorage.clear();
        //     localStorage.clear();
        // }
    };

    useEffect(() => {
        return () => {
            clearTimeout(handleOnIdle);
        };
    }, []);

    return (
        <>
            {children}
        </>
    );
};

export default SessionTimeout;